import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var SupportOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M3.33333 2.5C2.96833 2.5 2.5 2.77333 2.5 3.33333C2.5 7.11583 4.034 10.7277 6.639 13.361C9.27233 15.966 12.8842 17.5 16.6667 17.5C17.2267 17.5 17.5 17.0317 17.5 16.6667V13.7419C17.5 13.2877 17.1404 12.9177 16.6862 12.9069C16.1612 12.8944 15.5005 12.863 15.083 12.7897C14.6313 12.7097 14.0869 12.5557 13.7044 12.4365C13.4044 12.3432 13.0789 12.4248 12.8564 12.6465L11.0091 14.484C9.73245 13.8115 8.70926 13.0274 7.84342 12.1566C6.97259 11.2907 6.18845 10.2676 5.51595 8.99088L7.35352 7.14355C7.57518 6.92105 7.65681 6.59395 7.56348 6.29395C7.44514 5.91228 7.28945 5.36866 7.21029 4.91699C7.13612 4.49949 7.10643 3.8388 7.0931 3.3138C7.08227 2.85964 6.7123 2.5 6.25814 2.5H3.33333ZM10.8333 2.5C10.375 2.5 10 2.875 10 3.33333V10L11.6667 8.33333H16.6667C17.125 8.33333 17.5 7.95833 17.5 7.5V3.33333C17.5 2.875 17.125 2.5 16.6667 2.5H10.8333ZM11.6667 4.16667H15.8333V6.66667H11.6667V4.16667Z",
    fill: fill
  }));
};
export { SupportOutline as default };
//# sourceMappingURL=SupportOutline.js.map
